<template>
  <div class="atividades-programadas ml-4 mr-4" >
      <b-form>

                <!-- INDICADORES -->     
                <b-row >
                   
                    <b-col cols=2 class="mt-2">
                        <b-form-input id="fot-funcao" 
                            type="text"   
                            readonly                     
                            v-model="viagens.funcao"                         
                            placeholder="Programado" 
                        />                        
                    </b-col>

                    <b-col cols=2 class="mt-2">                        
                        <b-form-input id="fot-celular" only
                            type="text"
                            readonly                               
                            v-model="viagens.celular"                         
                            placeholder="Aguardando" 
                        />
                    </b-col>                       





                    <b-col cols=1 class="mt-2">                        
                        <b-form-input id="fot-cnh" 
                            type="text"  
                            readonly                      
                            v-model="viagens.cnh_cat"                         
                            placeholder="Cancelado" 
                        />
                    </b-col>   

                    <b-col cols=1 class="mt-2">                        
                        <b-form-input id="fot-cnh" 
                            type="text"  
                            readonly                      
                            v-model="viagens.cnh_cat"                         
                            placeholder="Realizado" 
                        />
                    </b-col>  

                   <b-col cols=1 class="mt-2">                        
                        <b-form-input id="fot-cnh" 
                            type="text"  
                            readonly                      
                            v-model="viagens.cnh_cat"                         
                            placeholder="Total Passageiro" 
                        />
                    </b-col>  

                    <b-col cols=1 class="mt-2">                        
                        <b-form-input id="fot-cnh" 
                            type="text"  
                            readonly                      
                            v-model="viagens.cnh_cat"                         
                            placeholder="FCV %" 
                        />
                    </b-col>   

                    <b-col cols=1 class="mt-2">                        
                        <b-form-input id="fot-cnh" 
                            type="text"  
                            readonly                      
                            v-model="viagens.cnh_cat"                         
                            placeholder="TOTAL TABELAS" 
                        />
                    </b-col>   

                    <b-col cols=1 class="mt-2">                        
                        <b-form-input id="fot-cnh" 
                            type="text"  
                            readonly                      
                            v-model="viagens.cnh_cat"                         
                            placeholder="ALT MOT" 
                        />
                    </b-col>   

                    <b-col cols=1 class="mt-2">                        
                        <b-form-input id="fot-cnh" 
                            type="text"  
                            readonly                      
                            v-model="viagens.cnh_cat"                         
                            placeholder="ALT COB" 
                        />
                    </b-col>   

                    <b-col cols=1 class="mt-2">                        
                        <b-form-input id="fot-cnh" 
                            type="text"  
                            readonly                      
                            v-model="viagens.cnh_cat"                         
                            placeholder="ALT CARRO" 
                        />
                    </b-col>   

                                                                  
                </b-row>


                <!-- FILTROS --> 


                  
          <b-row>
              <b-col cols=2 >

                
                
                
 
                
                <label for="select-garagem">Garagem</label>   <!-- {{garagem_value.map(a => a.id_filial) }}     -->
                <multiselect v-model="garagem_value"
                            @close="loadLinhas()"                                                       
                            :multiple="true"
                            :options="garagens"                              
                            :close-on-select="false" 
                            :clear-on-select="false" 
                            :preserve-search="true"   placeholder="Garagem" label="garagem" track-by="garagem" 
                            :preselect-first="true">
                    <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Garagem selecionada</span></template>                                        
                </multiselect> 
              </b-col>

              <b-col cols=1>
                <label for="select-modalidade">Lote</label>  
                
                <multiselect v-model="modalidade_value"                                                         
                            :multiple="true"
                            @close="loadLinhas()"  
                            :allowEmpty="true"
                            :options="modalidades"  
                            :close-on-select="false" 
                            :clear-on-select="false" 
                            :preserve-search="true"   placeholder="Lote" label="modalidade" track-by="modalidade" 
                            :preselect-first="false">
                    <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Lote selecionado</span></template>                                        
                </multiselect> 
              </b-col>

              <b-col cols=1>
                <label for="select-garagem">Linha</label>  
                <multiselect v-model="linha_value"                             
                            :multiple="true"
                            :options="linhas"  
                            :close-on-select="false" 
                            :clear-on-select="false" 
                            :preserve-search="true"   placeholder="Linha" label="linha" track-by="linha" 
                            :preselect-first="false">
                    <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Linha selecionada</span></template>                                        
                </multiselect> 
              </b-col>

              <b-col cols=1>
                <label for="select-garagem">Sentido</label>
                <multiselect v-model="sentido_value"
                            :multiple="true"
                            :options="sentidos"  
                            :close-on-select="false" 
                            :clear-on-select="false" 
                            :preserve-search="true"   placeholder="TP / TS" label="sentido" track-by="sentido" 
                            :preselect-first="false">
                    <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Sentido selecionado</span></template>                                        
                </multiselect> 
              </b-col>

              <b-col cols=2>
                <label for="select-garagem">Status</label> 
                <multiselect v-model="status_value"
                            :multiple="true"
                            :options="statuss"  
                            :close-on-select="false" 
                            :clear-on-select="false" 
                            :preserve-search="true"   placeholder="Selecione o status" label="status" track-by="status" 
                            :preselect-first="false">
                    <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Atividade selecionada</span></template>                                        
                </multiselect> 
              </b-col>

              <b-col cols=2>
                <label for="select-garagem">Atividade</label>
                <multiselect v-model="atividade_value"
                            :multiple="true"
                            :options="atividades"  
                            :close-on-select="false" 
                            :clear-on-select="false" 
                            :preserve-search="true"   placeholder="Selecione a atividade" label="atividade" track-by="atividade" 
                            :preselect-first="false">
                    <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Garagem selecionada</span></template>                                        
                </multiselect> 
              </b-col>

            <!--
              <b-col cols=1>
                   <label for="select-garagem">Sentido</label>
                <multiselect v-model="value_sentido"  :options="sentidos" :multiple="false" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Sentido" label="sentido" track-by="sentido" :preselect-first="false">
                    <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} sentido selecionado</span></template>
                </multiselect>              
              </b-col>
            -->
          
              <b-col cols=2>
                   <div>                            
                        <label  for="datepicker-placeholder">Data escala de serviço</label>
                        <b-form-datepicker id="datepicker-placeholder"  v-model="data_servico" placeholder="Selecione uma data" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                    </div>                     
              </b-col>

              <b-col cols=1 class="mt-4">
                    <b-button size="sm" variant="primary" class="mr-2 mt-2" 
                        v-on:click="loadViagensProgramadas()">Carregar</b-button>                        
              </b-col>
              
          </b-row>

          
 

          
    </b-form>
    <hr>    
    <b-table small hover striped sticky-header="618px"  :items="viagens" :fields="fields">                            
        
    </b-table>      
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import moment from 'moment'
import Multiselect from 'vue-multiselect'




export default {    
    name: 'TraAtividadesProgramadas',

    


    

    data: function() {
        return {               
            garagens: [],   // [] lista        
            garagem_value: [],
            
            modalidades: [],   // [] lista        
            modalidade_value:[],
            
            linhas: [],            // [] lista       
            linha_value:[],

            sentidos: [],
            sentido_value:[],

            statuss: [],
            status_value:[],

            atividades: [],
            atividade_value: [],
            
            data_servico: '',                         
            viagens:[],
            viagem:{},


            
            fields: [
                { key: 'linha', label: 'Linha', sortable: true },
                { key: 'tabela', label: 'Tabela', sortable: true },
                { key: 'sentido', label: 'Sentido', sortable: true },
                { key: 'carro_prog', label: 'Carro', sortable: true },                                
                { key: 'motorista_prog', label: 'Motorista', sortable: true },
                { key: 'cobrador_prog', label: 'Cobrador', sortable: true },
                
                { key: 'catraca1_iniciante', label: 'Iniciante', sortable: true },
                { key: 'catraca1_encerrante', label: 'Encerrante', sortable: true },
                { key: 'catraca1_passag', label: 'Passag Catraca1', sortable: true },

                { key: 'catraca2_iniciante', label: 'Iniciante', sortable: true },
                { key: 'catraca2_encerrante', label: 'Encerrante', sortable: true },
                { key: 'catraca2_passag', label: 'Passag Catraca2', sortable: true },

                { key: 'passageiro_total', label: 'Passag Total', sortable: true },

                { key: 'status', label: 'Status', sortable: true },
                { key: 'atividade', label: 'Atividade', sortable: true },

                
                { key: 'cheg_prog', label: 'cheg_prog', sortable: true, formatter: (value, key, viagens) => {
                    return moment(viagens.cheg_prog).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },   

               
                { key: 'said_prog', label: 'saida_prog', sortable: true, formatter: (value, key, viagens) => {
                    return moment(viagens.said_prog).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },   

                { key: 'chegada_real', label: 'chegada_real', sortable: true },
                { key: 'saida_real', label: 'saida_real', sortable: true },

                { key: 'fiscal', label: 'Fiscal', sortable: false }
         

       /*
                { key: 'po_real', label: 'Minutos #', sortable: true, formatFn: (value, key, viagens) => {
                    return moment(viagens.po_real).format('HH:mm:ss');} },        //:ms refere-se a miléssimo de segundos       
            

         
                { key: 'chegada_real', label: 'Chegada', sortable: true, formatter: (value, key, viagens) => {
                    return moment(viagens.chegada_real).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },  

                { key: 'saida_real', label: 'Chegada', sortable: true, formatter: (value, key, viagens) => {
                    return moment(viagens.saida_real).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },  

                { key: 'po_real', label: 'Para Ope Real', sortable: true, formatter: (value, key, viagens) => {
                    return moment(viagens.saida_real).format('HH:mm').replace('Data inválida','-') ; }  },  

*/


                
                
            ]
        }        
    },

    components: {
        Multiselect
    },
    methods: {

      
        loadGaragens() {
          const url = `${baseApiUrl}/trafego/garagem`          
          axios.get(url).then(res => {            
            this.garagens = res.data.map(garagem => {                             
              return { ... garagem, id_filial: garagem.id_filial, garagem: garagem.garagem }              
            })
          })          
        },

        loadModalidades() {
          const url = `${baseApiUrl}/trafego/modalidade`          
          axios.get(url).then(res => {            
            this.modalidades = res.data.map(modalidade => {                                   
              return { id_modalidade: modalidade.id_modalidade, modalidade: modalidade.modalidade }
            })            
          })          
        },


         loadLinhas() {
            let corpo = {    
                "id_filial"    : `${[this.garagem_value.map(a => a.id_filial)]}`,            
                "id_modalidade": `${[this.modalidade_value.map(m => m.id_modalidade)]}`                  
            };

          const url = `${baseApiUrl}/trafego/linha`
          return axios.post(url,corpo).then(res => {
             this.linhas = res.data.map(linha => {
              return { ... linha}
            })
          })          
        },

            
        loadSentido() {         
          const url = `${baseApiUrl}/trafego/linha/sentido`
          return axios.get(url).then(res => {
             this.sentidos = res.data.map(sen => {
              return { ... sen}
            })
          })          
        },

        loadStatus() {         
          const url = `${baseApiUrl}/trafego/linha/status`
          return axios.get(url).then(res => {
             this.statuss = res.data.map(sta => {
              return { ... sta}
            })
          })          
        },

        loadAtividade() {
          const url = `${baseApiUrl}/trafego/linha/atividade`          
          axios.get(url).then(res => {            
            this.atividades = res.data.map(ati => {                                   
              return { ... ati }
            })            
          })          
        },

        loadViagensProgramadas() {
            let corpo = {    
                "data_operacao": `${this.data_servico}`,
                "id_filial"    : `${[this.garagem_value.map(f => f.id_filial)]}`,            
                "id_modalidade": `${[this.modalidade_value.map(m => m.id_modalidade)]}`,
                "id_linha": `${[this.linha_value.map(l => l.id_linha)]}`,
                "sentido": `${[this.sentido_value.map(s => s.sentido)]}`,
                "id_status": `${[this.status_value.map(ss => ss.id_status)]}`,
                "id_atividade": `${[this.atividade_value.map(a => a.id_atividade)]}`,                                 
                                
            };
          
          const url = `${baseApiUrl}/operacao/viagens/ponto`          
          axios.post(url,corpo).then(res => {
            this.viagens = res.data.map(via => {
                            return { ... via
                                
               }              
            })
            
          })
        }, 

    },

    mounted() {        
        this.loadGaragens()
        this.loadModalidades()
        this.loadSentido()    
        this.loadStatus()
        this.loadAtividade()         
           
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

.table{
    font-size: 0.7em;
}


</style>
